module.exports = __webpack_public_path__ + "img/home_img_16.346386f6.png";